import focus from "./focus.js";

const destroy = (element, options) => {
    element.removeEventListener('focus', focus);
};

export default destroy;